<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <Logo :biz="!this.formData.isPrivateClient ? 'corp':'priv'"  />
    </div>
    <div class="container">
      <h2>you're all set!</h2>
      <!-- <p class="text-center">
        Do you need any help?&nbsp;<a
          href=""
          data-target="#helpModal"
          data-toggle="modal"
          >Get in touch
        </a>
      </p> -->
      <div class="signup-form wizard clearfix pt-0">
        <div class="steps clearfix text-center">
          <img src="/assets/img/success-checked-100.png" />
        </div>
        <div class="content clearfix">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="info-text text-center">
                You're now ready to use our Online platform and start
                transferring money.
              </h4>
            </div>
            <div class="col-sm-12 mt-3 text-center">
              <p class="f-size-14">
              
                <a
                  href="https://portal.smartcurrencyexchange.com/login"
                  target="_blank" 
                  >Login now</a>&nbsp;on our Smart Online Platform
              </p>
            </div>
            <template v-if="showAppOption">
              <div class="col-sm-12 text-center">
                <p class="f-size-14">Or</p>
                <p class="f-size-14">
                Download our "Smart Money Transfer" app - The quickest, easiest and most secure way to transfer euros.<br />
                </p>
              </div>
              <div class="col-sm-6 mt-3" v-if="showIos">
                <a
                  href="https://apps.apple.com/us/app/smart-money-transfer/id1492120939"
                  target="_blank"
                  ><img
                    src="/assets/img/download-apple_2.png"
                    title="App Store"
                    class="img-100"
                /></a>
              </div>
              <div class="col-sm-6 mt-3" v-if="showAndroid">
                <a
                  href="https://play.google.com/store/apps/details?id=xyz.appmaker.yhnebi"
                  target="_blank"
                  ><img
                    src="/assets/img/download-android_2.png"
                    title="Google Play"
                    class="img-100"
                /></a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Common } from "@/helper/common";
import Logo from "@/components/ui/Logo.vue";
import { mapGetters } from "vuex";
export default {
  name: "Success",
  data() {
    return {
      showAndroid: false,
      showIos: false,
      showAppOption: false,
    };
  },
   computed: {
    ...mapGetters({
      formData: "getFormData"
    }),
  },
  created() {
    const os = Common.getMobileOS();

    if (this.formData.isPrivateClient) {
      if (os == "android") {
        this.showAndroid = true;
        this.showAppOption = true;
      } else if (os == "ios") {
        this.showIos = true;
        this.showAppOption = true;
      } else {
        this.showAndroid = true;
        this.showIos = true;
        this.showAppOption = true;
      }
    }
  },
  components: {
    Logo,
  },
};
</script>
